"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ToobarItem = require("./ToobarItem");

var _ToobarItem2 = _interopRequireDefault(_ToobarItem);

var _ToolbarGroup = require("./ToolbarGroup");

var _ToolbarGroup2 = _interopRequireDefault(_ToolbarGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ToolbarOption = function () {
    function ToolbarOption(titulo, onClick, options, icone) {
        _classCallCheck(this, ToolbarOption);

        this.titulo = titulo;
        this.onClick = onClick;
        this.options = options || [];
        this.icone = icone;
    }

    _createClass(ToolbarOption, [{
        key: "addOption",
        value: function addOption(option) {
            this.options.push(option);
        }
    }, {
        key: "addOptions",
        value: function addOptions(options) {
            this.options = options;
        }
    }, {
        key: "getToolbarIem",
        value: function getToolbarIem() {
            if (!this.options || this.options.length === 0) return _react2.default.createElement(_ToobarItem2.default, { key: this.titulo, content: this.titulo, onClick: this.onClick, icon: this.icone });else return _react2.default.createElement(
                _ToolbarGroup2.default,
                { title: this.titulo, key: this.titulo },
                this.options.map(function (o) {
                    return o.getToolbarIem();
                })
            );
        }
    }]);

    return ToolbarOption;
}();

exports.default = ToolbarOption;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/structure/Tab/ToolbarOption.js
// module id = 1142
// module chunks = 0